<template>
    <div
        v-qa="'grid-view-toggle'"
        class="grid-view-toggle"
    >
        <button
            v-qa="'select-grid'"
            class="button"
            :class="getClassButton(!tableView)"
            type="button"
            @click="tableView = false"
        >
            <span class="label"> Grid view </span>
            <img
                :src="iconGridCards"
                class="icon"
                alt="Grid view"
            />
        </button>

        <button
            v-qa="'select-table'"
            class="button"
            :class="getClassButton(tableView)"
            type="button"
            @click="tableView = true"
        >
            <span class="label"> List view </span>
            <img
                :src="iconGridTable"
                class="icon"
                alt="List view"
            />
        </button>
    </div>
</template>

<script setup lang="ts">
import iconGridCards from '@/assets/icons/grid_cards.svg'
import iconGridTable from '@/assets/icons/grid_table.svg'

const tableView = defineModel<boolean>('tableView', { default: false })

const getClassButton = (isActive: boolean) => ({
    inactive: !isActive,
})
</script>

<style scoped lang="scss">
.grid-view-toggle {
    margin-right: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    .button {
        display: flex;
        align-items: center;
        line-height: 20px;
        padding: 10px 15px;
        border-right: 1px solid $grey-200;
        color: $blue;

        @include min-width(1024) {
            padding: 0;
            border: none;
        }

        &.inactive {
            .label,
            .icon {
                opacity: 0.3;
                color: $slate;
                filter: none;
            }
        }
    }

    .label {
        display: none;

        @include min-width(1024) {
            height: 20px;
            line-height: 20px;
            display: block;
        }
    }

    .icon {
        height: 20px;
        line-height: 20px;
        filter: invert(29%) sepia(12%) saturate(2497%) hue-rotate(181deg)
            brightness(92%) contrast(91%);

        @include min-width(1024) {
            height: 16px;
            margin: 0 16px 0 8px;
        }
    }
}
</style>
